import React, {useMemo} from 'react'
import ScrollBar from 'react-perfect-scrollbar'
import {ScrollDirection} from '@components/common/with-scrollbar/types'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'

export interface WithScrollbarProps {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  scrollDirection?: ScrollDirection
  drag?: boolean
  wheelPropagation?: boolean
  wheelSpeed?: number
  forceCustomScroll?: boolean
  maxWidth?: string | number
  maxHeight?: string | number
}

const resolveCssValue = (value: string | number) => {
  return typeof value === 'number' ? `${value}px` : value
}

export const SharedWithScrollbar = React.forwardRef<
  ScrollBar,
  WithScrollbarProps
>((props: WithScrollbarProps, ref) => {
  const {children, maxWidth, maxHeight, style, ...rest} = props

  const finalStyle = useMemo(() => {
    const nextStyle = {
      ...style
    }
    if (maxWidth) {
      nextStyle.maxWidth = resolveCssValue(maxWidth)
    }
    if (maxHeight) {
      nextStyle.maxHeight = resolveCssValue(maxHeight)
    }
    return nextStyle
  }, [maxWidth, maxHeight, style])

  return (
    <WithPerfectScrollbar {...rest} style={finalStyle} ref={ref}>
      {children}
    </WithPerfectScrollbar>
  )
})
